import { useNavigate } from 'react-router';
import { NotFoundLayout, NotFoundHeader, NotFoundSubheader, NotFoundIconWrapper } from './styles';
import NotFoundIcon from './images/404.svg?react';
import { Button } from '@/components/Button/Button';
import { Box } from '@/components/Box/Box';
import { useUser } from '@/context/userContext';
import { getDashboardRedirectPath } from '@/bundle/Auth/LoginFlow/LoginPage/const/const';

export const NotFoundAuthPage = () => {
  const { currentRole } = useUser();
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    const url = getDashboardRedirectPath(currentRole);

    navigate(url);
  };

  return (
    <NotFoundLayout>
      <NotFoundIconWrapper>
        <NotFoundIcon></NotFoundIcon>
      </NotFoundIconWrapper>
      <NotFoundHeader>Page Not Found</NotFoundHeader>
      <NotFoundSubheader>
        We cannot find the page you are looking for!
        <br />
        Please try again.
      </NotFoundSubheader>
      <Box display='flex' flexDirection='column' rowGap='24px'>
        <Button width={200} onClick={navigateToDashboard}>
          Return to Dashboard
        </Button>
      </Box>
    </NotFoundLayout>
  );
};
